import { SystemEntity } from '@erp/shared-types';

/**
 * Display name mapping for system entities
 * Maps each SystemEntity to a human-readable display name
 */
export const systemEntityDisplayNames: Record<SystemEntity, string> = {
  // CORE
  [SystemEntity.CORE_MEMORY_BANK_NOTE]: 'Memory Bank Note',
  [SystemEntity.CORE_MEMORY_BANK_NOTE_USAGE]: 'Memory Bank Usage',
  [SystemEntity.ORGANIZATION]: 'Organization',
  [SystemEntity.CORE_COMPANY]: 'Company',
  [SystemEntity.CORE_FILE]: 'File',
  [SystemEntity.CORE_DOCUMENT]: 'Document',
  [SystemEntity.CORE_DOCUMENT_OCR_RESULT]: 'OCR Result',

  // AR
  [SystemEntity.AR_CUSTOMER]: 'Customer',
  [SystemEntity.AR_CUSTOMER_PRODUCT]: 'Customer Product',
  [SystemEntity.AR_STAGED_SALES_ORDER]: 'Staged Sales Order',
  [SystemEntity.AR_DISCOUNT_GROUP]: 'Discount Group',
  [SystemEntity.AR_DRAFT_SALES_ORDER]: 'Draft Sales Order',
  [SystemEntity.AR_SALES_ORDER]: 'Sales Order',
  [SystemEntity.AR_SALES_ORDER_LINE_ITEM]: 'Sales Order Line Item',
  [SystemEntity.AR_PAYMENT]: 'AR Payment',
  [SystemEntity.AR_INVOICE]: 'AR Invoice',
  [SystemEntity.AR_PAYMENT_APPLICATION]: 'Payment Application',
  [SystemEntity.AR_REMITTANCE_ADVICE]: 'Remittance Advice',
  [SystemEntity.AR_SHIPMENT]: 'AR Shipment',
  [SystemEntity.AR_COLLECTION_THREAD]: 'Collection Thread',
  [SystemEntity.AR_SAVED_REPORT]: 'AR Report',
  [SystemEntity.IM_TRANSFER_ORDER]: 'Transfer Order',
  [SystemEntity.IM_TRANSFER_ORDER_LINE_ITEM]: 'Transfer Order Line Item',
  [SystemEntity.IM_DRAFT_PURCHASE_ORDER]: 'Draft Purchase Order',

  // AP
  [SystemEntity.AP_INVOICE]: 'AP Invoice',
  [SystemEntity.AP_INVOICE_LINE_ITEM]: 'AP Invoice Line Item',
  [SystemEntity.AP_SUPPLIER]: 'Supplier',
  [SystemEntity.INTERNAL_PURCHASE_ORDER]: 'Purchase Order',
  [SystemEntity.INTERNAL_PURCHASE_ORDER_LINE_ITEM]: 'PO Line Item',

  // FINANCE
  [SystemEntity.PAYMENT]: 'Payment',
  [SystemEntity.FINANCIAL_TRANSACTION]: 'Financial Transaction',
  [SystemEntity.CHARGE]: 'Charge',

  // REBATES
  [SystemEntity.REBATE_AGREEMENT]: 'Rebate Agreement',

  // PRICING
  [SystemEntity.PRICING_SPA]: 'SPA',

  // SUPPLY CHAIN MANAGEMENT
  [SystemEntity.SCM_SHIPMENT]: 'Shipment',

  // EMAILS
  [SystemEntity.INBOUND_EMAIL]: 'Inbound Email',
  [SystemEntity.OUTBOUND_EMAIL]: 'Outbound Email',

  // WORKFLOWS
  [SystemEntity.WORKFLOW_DEFINITION]: 'Workflow Definition',
  [SystemEntity.WORKFLOW_RUN]: 'Workflow Run',
  [SystemEntity.STEP_RUN]: 'Step Run',

  // AI
  [SystemEntity.AI_AGENT_RUN]: 'Agent Run',
  // TODO: AI_EXTRACTION_RESULT is a generic entity but today only AP invoice
  // extraction produces one, so we keep the legacy label. When more schemas
  // land, derive the display name from the row's schema-definition ref.
  [SystemEntity.AI_EXTRACTION_RESULT]: 'AP Invoice Extraction Result',
  [SystemEntity.TASK]: 'Task',

  // EXTERNAL REFERENCES
  [SystemEntity.EXTERNAL_SYSTEM_REFERENCE]: 'External Reference',
};

/**
 * Get the display name for a system entity
 */
export function getEntityDisplayName(entityType: SystemEntity): string {
  return (
    systemEntityDisplayNames[entityType] ?? `Unknown Entity (${entityType})`
  );
}
